export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function getLanguage(): string {
  return /fr-CA/.test(location.href) || /fr/.test(location.href) ? 'fr-CA' : 'en';
}
